module.exports = __webpack_public_path__ + "static/media/makeup.5a879ee8.jpg";